/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { css, jsx } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import { isVisualRefreshEnabled } from '@atlassian/jira-visual-refresh-rollout/src/feature-switch/index.tsx';
import messages from './messages.tsx';

type Props = {
	popularity: number;
};

function Popularity(props: Props): JSX.Element {
	const { popularity } = props;

	const { formatMessage } = useIntl();

	if (isVisualRefreshEnabled()) {
		return (
			<div css={containerStyles}>
				<div css={textContainerStyles}>{formatMessage(messages.popularity, { popularity })}</div>
			</div>
		);
	}

	return <div css={containerStylesOld}>{formatMessage(messages.popularity, { popularity })}</div>;
}

export default Popularity;

const containerStyles = css({
	display: 'flex',
	flexDirection: 'row',
	alignItems: 'center',
	// Setting a specific height here to match the rest of the directory table cells since the text height is 20px, and 10px padding on top and bottom is not possible with tokens
	minHeight: token('space.500'),
	minWidth: token('space.300'),
});

const textContainerStyles = css({
	overflow: 'hidden',
	wordWrap: 'break-word',
});

const containerStylesOld = css({
	display: 'flex',
	flex: '1 1 auto',
	flexDirection: 'row',
	width: '100%',
	whiteSpace: 'nowrap',
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	paddingTop: token('space.150'),
	paddingBottom: token('space.150'),
});
